module.exports = __webpack_public_path__ + "img/home.830da07b.svg";